<template>
  <div class="my-4 w-full px-2">
    <h1 horizontalAlignment="left" class="font-bold text-2xl text-bs-dark-bg dark:text-white text-left pt-0 mb-4 w-full d-block">Last 5 games
    </h1>
    <div class="w-full flex justify-between"  v-for="(stat,index) in stats" :key="index">
        <span  class="font-bold text-lg  mb-1 text-bs-blue-dark">{{formatNumber(stat.home)}}</span>
        <span class="text-md dark:text-white text-center">{{stat.title}}</span>
        <span  col="2" class="font-bold text-lg  mb-1 text-bs-blue-dark text-right">{{formatNumber(stat.away)}}</span>
    </div>
  </div>
</template>

<script>
const STATS = {
  "halfTimeScoreAvg": "Avg. Goals Scored 1st Half",
  "fullTimeScoreAvg": "Avg. Goals Scored",
  "avgHalfTimeLoss": "Avg. Goals Conceded 1st Half",
  "avgFullTimeLoss": "Avg. Goals Conceded"
}
export default {
  props: {
    "homeData": {
      type: Object
    },
    "awayData": {
      type: Object
    }
  },
  computed: {
    stats: function () {
      let stats = Object.keys(STATS)
      let obj = []
      stats.forEach(stat => {
        let home = this.homeData[stat]
        let away = this.awayData[stat]
        if (typeof home !== 'undefined' && typeof away !== 'undefined') {
          obj.push({
            title: STATS[stat],
            home,
            away
          })
        }
      })
      return obj
    }
  },
  methods: {
    formatNumber: function (n) {
      return n?.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 2})
    }
  }
}
</script>

<style>
</style>